import { bigDataHttp, otmsHttp, bmsBigData, smartHttp } from '@/utils/http/index.js';

// 线路报价列表
export function getStarbucksRoutPrice(data) {
    return bigDataHttp.post('/api/web/OMS/starbucksRoutPrice', data);
}

export function getQuotationPage(data, params) {
    return smartHttp.post(`/starbucks/inbound/quotation/page?page=${params.page}&size=${params.size}`, data, params);
}

// 导入报价单
export function importInboundQuotation(data) {
    return smartHttp.post('/starbucks/inbound/quotation/import', data);
}

//

// 站点信息列表
export function getStarbucksStation(data) {
    return bigDataHttp.post('/api/web/OMS/starbucks_station_info', data);
}

// 查询报价单列表
export function getQuotationList(data, params) {
    // return bmsBigData.post('/gxzw/selectQuotation', data);
    console.log(1111, params);
    return smartHttp.post(`/starbucks/inbound/quotation/freezing/page?page=${params.page}&size=${params.size}`, data, params);
}

// 站点列表
export function stationList(data) {
    return bmsBigData.post('/gxzw/stationList', data);
}

// 新增报价单
export function insertQuotation(data) {
    return bmsBigData.post('/gxzw/insertQuotation', data);
}

// 修改报价单
export function updateQuotation(data) {
    return bmsBigData.post('/gxzw/updateQuotation', data);
}

// 删除报价单
export function deleteQuotation(data) {
    return bmsBigData.post('/gxzw/deleteQuotation', data);
}

// 查询站点信息列表
export function getSelectStation(data) {
    return bmsBigData.post('/gxzw/selectStation', data);
}

// 新增站点
export function insertStation(data) {
    return bmsBigData.post('/gxzw/insertStation', data);
}

// 修改站点
export function updateStation(data) {
    return bmsBigData.post('/gxzw/updateStation', data);
}

// 删除站点
export function deleteStation(data) {
    return bmsBigData.post('/gxzw/deleteStation', data);
}

// 获取省市区
export function cityAreaTree(data) {
    return otmsHttp.post('/base_plus/city_area/tree', data);
}

// 导入报价单
export function importQuotation(data) {
    return smartHttp.post('/starbucks/inbound/quotation/freezing/import', data);
    // return bmsBigData.post('/gxzw/importQuotation', data);
}

// 下载末班
export function getConfig(data) {
    return otmsHttp.request({ url: '/config/query', method: 'post', data });
}

/**
 * 获取修改日志数据
 * yapi: https://yapi.ops.yunlizhi.cn/project/697/interface/api/27713
 */
export function getOperateLogApi(data = {}) {
    return bmsBigData.request({
        url: '/gxzw/operation_log',
        method: 'post',
        data
    });
}
